
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class NotFound extends Vue {
  @Prop() item?: string
}
